import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  orders: [],
  totalOrders: 0,
  customerOrders: [],
  totalCustomerOrders: 0,
  loading: false,
  status: null,
  error: null,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
